// scripts
import './scripts/admin.js';
import './scripts/apply.js';
import './scripts/general.js';
import './scripts/jqueryLib.js';
import './scripts/sticky.js';

// lib
import './lib/modernizr-custom.js';

// Initialize sticky
document.addEventListener('DOMContentLoaded', () => {
  const sidebars = document.querySelectorAll('.sidebarz');
  sidebars.forEach(sb => {
    $(sb).sticky({ topSpacing: 10 });
  });
});
